import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';
import { Store } from '@/stores';

export default function useStateOfAirlineToggle(store: Store) {
  return useMapStoreStateToClientState(store, (store) => ({
    airlineFilter: store.appStore.stepByStepSearchPage.inbound.filters.airline,
    airlineCode: store.appStore.stepByStepSearchPage.inbound.outboundItinerary?.validatingCarrier,
    isReady: store.appStore.stepByStepSearchPage.inbound.filters.airline.isReady,
    isResourcesFetched: store.appStore.flightInfo.resources.isFetched,
  }));
}
